// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/helpers/util';
import Vue from 'vue';
import router from '@/routes';
import i18n from '@/providers/i18n';
import store from '@/providers/context';
import fields from '@/providers/fields';
import '@/providers/validation';
import '@/providers/svgicons';
import '@/providers/common_components';
import '@/providers/modals';
import '@/providers/filters';
import '@/providers/toast';
import Wizard from '@/helpers/components/display/Wizard';

import './assets/scss/_fix.scss';
import './assets/scss/_common.scss';

Vue.config.productionTip = false;

/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  i18n,
  store,
  fields,
  template:
    '<div>' +
      '<dialogs-wrapper class=dialogsholder />' +
      '<router-view v-if="progress >= loaders.length"/>' +
      '<Wizard v-else class="firsttime-loading xs lonely" logo="vertical">' +
        '<figure class="timeline" v-if="percentage >= 0 && percentage <= 100">' +
          '<label class="remaining">{{ \'js.content_please_wait\' | trans }}</label>' +
          '<ins class="progress" :style="\'width:\' + percentage + \'%\'"></ins>' +
        '</figure>' +
      '</Wizard>' +
    '</div>',
  components: {Wizard},
  mounted: function () {
    this.$store.commit('refresh');
  },
  data () {
    return {loaders: ['user', 'apptoken', 'billing_plan']};
  },
  computed: {
    progress () {
      var per = 0;
      for (let loader of this.loaders) {
        if (this.$store.getters[loader]) {
          per++;
        }
      }
      return per;
    },
    percentage () {
      return 100 * this.progress / this.loaders.length;
    },
  },
});



// WEBPACK FOOTER //
// ./src/main.js